import styled from 'styled-components';

export const WholeWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: ${({ noborder }) => (noborder ? 'none' : '1px solid #05000033')};
  line-height: 2.4rem;
  font-family: Space-r;
  padding: 2rem 3.6rem;
  letter-spacing: 0.08rem;
  justify-content: space-between;
`;
export const CloseX = styled.div`
  font-size: 2rem;
  color: #4a4a4a;
  opacity: 0.6;
  font-family: Roboto-m;
  cursor: pointer;
`;
export const ModalMain = styled.div`
  padding: ${({ padding }) => (padding ? padding : '3.6rem')};
`;

export const ModalColumn = styled.div`
  width: Calc(50% - 12px);
`;

export const ModalInput = styled.div`
  width: ${({ small }) => (small ? 'Calc(50% - 8px)' : '100%')};
  height: ${({ height }) => (height ? height : '7.5rem')};
  flex-grow: ${({ grow }) => (grow ? '1' : 'none')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Roboto-m;
  font-size: 1.4rem;
  color: #37333399;
  margin-bottom: 2.4rem;
`;

export const ModalTextArea = styled.div`
  max-height: 100%;
  width: 100%;
`;

export const FlexWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonWrapper = styled.div`
  width: Calc(50% - 12px);
  height: 4.8rem;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '1.6rem')};
`;
